import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import {
  PlaidTransactionQuery,
  PlaidTransactionResponse,
  TransactionState,
} from "./type";
import { generateQueryString } from "../helper/helpers";

export const getTransactions = createAsyncThunk(
  "web/get-customers",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/transactions?page=${payload?.page || 1}&per_page=${
          payload?.per_page || "30"
        }${payload?.status ? `&filter[status]=${payload?.status}` : ``}${
          payload?.type ? `&type=${payload?.type}` : ``
        }${
          payload?.currency_type
            ? `&filter[currency_type]=${payload?.currency_type}`
            : ``
        }${payload?.search ? `&search=${payload?.search}` : ``}${
          payload?.date ? `&filter[date]=${payload?.date}` : ``
        }${payload?.amount ? `&filter[amount_range]=${payload?.amount}` : ``}${
          payload?.export ? `&export=${payload?.export}` : ``
        }`,
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_TTRANSACTIONS(obj));
        // SET_TTRANSACTIONS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getTransactionsCsv = createAsyncThunk(
  "web/get-customers-export",
  
  async (payload: any, thunkAPI) => {
    try {
      toast.info("Download in progress...", {
        position: "top-right",
      });
      const data = await axios.get(
        `/admin/transactions?page=${payload?.page || 1}&per_page=${
          payload?.per_page || "30"
        }${payload?.status ? `&filter[status]=${payload?.status}` : ``}${
          payload?.type ? `&type=${payload?.type}` : ``
        }${
          payload?.currency_type
            ? `&filter[currency_type]=${payload?.currency_type}`
            : ``
        }${payload?.search ? `&search=${payload?.search}` : ``}${
          payload?.date ? `&filter[date]=${payload?.date}` : ``
        }${
          payload?.amount ? `&filter[amount_range]=${payload?.amount}` : ``
        }&export=csv`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === 200) {
        const obj = data?.data;
        const url = window.URL.createObjectURL(new Blob([obj]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "transaction report.csv");
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getTransactionCount = createAsyncThunk(
  "web/get-transaction-count",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/transactions/count${
          payload?.type ? `?type=${payload?.type}` : ``
        }${payload?.currency ? `&source_currency=${payload?.currency}` : ``}${
          payload?.amount ? `&filter[amount_range]=${payload?.amount}` : ``
        }${payload?.date ? `&filter[date]=${payload?.date}` : ``}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_TRANSACTION_COUNT(obj));
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getTransactionDetails = createAsyncThunk(
  "web/get-transaction-details",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/transactions/${payload.id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_TTRANSACTIONS_DETAIL(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const approveTransactionPayout = createAsyncThunk(
  "web/approve-transaction-payout",
  async (payload: { id: string; comment?: string | null }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/transactions/approve/${payload.id}`,
        { comment: payload.comment || null },
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const rejectTransactionPayout = createAsyncThunk(
  "web/reject-transaction-payout",
  async (payload: { id: string; rejection_reason: string }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/transactions/reject/${payload.id}`,
        { rejection_reason: payload.rejection_reason },
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const retryTransactionPayout = createAsyncThunk(
  "web/retry-transaction-payout",
  async (payload: { id: string }, thunkAPI) => {
    try {
      const data = await axios.post(`/admin/transactions/retry/${payload.id}`);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getQueuingTransaction = createAsyncThunk(
  "web/get-transaction-queuing",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/queued-payouts${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_QUEUING_TRANSACTIONS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const disburtAllQueuedTransactions = createAsyncThunk(
  "web/disburt-all-queued-transactions",
  async (_, thunkAPI) => {
    try {
      const data = await axios.post(`/admin/queued-payouts/disburse-all`);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const disburtSingleQueuedTransactions = createAsyncThunk(
  "web/disburt-all-single-transactions",
  async (swapDeal: string, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/queued-payouts/${swapDeal}/disburse`,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getZojapayTransaction = createAsyncThunk(
  "web/get-transaction-zojapay",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/partners/zojapay-transactions${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_ZOJAPAY_TRANSACTIONS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getZojapayTransactionCsv = createAsyncThunk(
  "web/get-zojapay-transaction-export",
  async (payload: any, thunkAPI) => {
    try {
      toast.info("Download in progress...", {
        position: "top-right",
      });
      const data = await axios.get(
        `/admin/partners/zojapay-transactions${generateQueryString({
          ...payload,
          export: "csv",
        })}`,
        { responseType: "blob" },
      );

      const contentType = data?.headers?.["content-type"] as
        | string
        | undefined;
      const isJsonResponse = !!contentType?.includes("application/json");

      if (isJsonResponse) {
        const json = await tryParseBlobAsJson(data.data as Blob);
        if (json?.status === false || json?.status === "fail") {
          toast.error(json?.message || "Export failed", {
            position: "top-right",
          });
          return thunkAPI.rejectWithValue(json);
        }
      }

      if (data?.status === 200 && !isJsonResponse) {
        const extension = getExportExtension(contentType, "csv");
        const url = window.URL.createObjectURL(data.data as Blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `zojapay transactions report.${extension}`);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      const errorBlob = error?.response?.data;
      if (errorBlob instanceof Blob) {
        const json = await tryParseBlobAsJson(errorBlob);
        if (
          (json?.status === false || json?.status === "fail") &&
          error.response?.status !== 401
        ) {
          toast.error(json?.message || "Export failed", {
            position: "top-right",
          });
          return thunkAPI.rejectWithValue(json);
        }
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getBridgeTransaction = createAsyncThunk(
  "web/get-transaction-bridge",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/partners/bridge-transactions${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_BRIDGE_TRANSACTIONS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getPlaidTransaction = createAsyncThunk(
  "web/get-transaction-plaid",
  async (payload: PlaidTransactionQuery, thunkAPI) => {
    try {
      // generateQueryString doesn't encode values, and search can hold
      // characters like "+", "&" or "#" (emails, names), so encode them here.
      const encoded = Object.fromEntries(
        Object.entries(payload).map(([key, value]) => [
          key,
          typeof value === "string" ? encodeURIComponent(value) : value,
        ]),
      );
      const data: any = await axios.get(
        `/admin/partners/plaid-transactions${generateQueryString(encoded)}`,
      );

      // The shared axios interceptor resolves failed requests (returning the
      // error, or nothing) instead of throwing, so anything that isn't a
      // successful response with a list is treated as a failure.
      const body = data?.data;
      if (
        !data ||
        data?.isAxiosError ||
        !body?.status ||
        body?.status === "fail" ||
        !Array.isArray(body?.data)
      ) {
        const message =
          data?.response?.data?.message || body?.message || data?.message;
        // No response at all means the interceptor already handled (and
        // toasted) the error; 401s are handled by the session flow.
        if (data && data?.response?.status !== 401) {
          toast.error(message || "Unable to fetch Plaid transactions", {
            position: "top-right",
          });
        }
        return thunkAPI.rejectWithValue(message || null);
      }

      return { data: body.data, meta: body.meta } as PlaidTransactionResponse;
    } catch (error: any) {
      toast.error(error?.message || "Unable to fetch Plaid transactions", {
        position: "top-right",
      });
      return thunkAPI.rejectWithValue(error?.message || null);
    }
  },
);

export const getStripeTransaction = createAsyncThunk(
  "web/get-transaction-stripe",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/stripe-transactions${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_STRIPE_TRANSACTIONS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const EXPORT_EXTENSION_BY_CONTENT_TYPE: Record<string, string> = {
  "text/csv": "csv",
  "application/csv": "csv",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
};

const getExportExtension = (
  contentType: string | undefined,
  fallback: string,
) => {
  const normalized = (contentType || "").split(";")[0].trim().toLowerCase();
  return EXPORT_EXTENSION_BY_CONTENT_TYPE[normalized] || fallback;
};

// Reads a Blob back out as parsed JSON, or null if it isn't JSON at all —
// used because responseType "blob" turns even a JSON error body into a Blob.
const tryParseBlobAsJson = async (blob: Blob): Promise<any | null> => {
  try {
    const text = await blob.text();
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
};

export const getBridgeTransactionCsv = createAsyncThunk(
  "web/get-bridge-transaction-export",
  async (payload: { year: number | string; month: number | string }, thunkAPI) => {
    try {
      toast.info("Download in progress...", {
        position: "top-right",
      });
      const data = await axios.get(
        `/admin/partners/bridge-transactions${generateQueryString({
          year: payload?.year,
          month: payload?.month,
          export: "csv",
        })}`,
        { responseType: "blob" },
      );

      const contentType = data?.headers?.["content-type"] as
        | string
        | undefined;
      const isJsonResponse = !!contentType?.includes("application/json");

      if (isJsonResponse) {
        const json = await tryParseBlobAsJson(data.data as Blob);
        if (json?.status === false || json?.status === "fail") {
          toast.error(json?.message || "Export failed", {
            position: "top-right",
          });
          return thunkAPI.rejectWithValue(json);
        }
      }

      if (data?.status === 200 && !isJsonResponse) {
        const extension = getExportExtension(contentType, "csv");
        const url = window.URL.createObjectURL(data.data as Blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `bridge transactions report ${payload?.year}-${String(
            payload?.month,
          ).padStart(2, "0")}.${extension}`,
        );
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      // Error responses also arrive as a Blob when responseType is "blob".
      const errorBlob = error?.response?.data;
      if (errorBlob instanceof Blob) {
        const json = await tryParseBlobAsJson(errorBlob);
        if (
          (json?.status === false || json?.status === "fail") &&
          error.response?.status !== 401
        ) {
          toast.error(json?.message || "Export failed", {
            position: "top-right",
          });
          return thunkAPI.rejectWithValue(json);
        }
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const initialState: TransactionState = {
  loading: false,
  loading_count: false,
  loading_approval: false,
  loading_rejection: false,
  loading_retry: false,
  transactions: {},
  transactions_details: {},
  transaction_count: [],
  queuing_transactions: {},
  loading_queuing: false,
  loading_disburse: false,
  loading_zojapay: false,
  zojapy_transaction: [],
  loading_bridge: false,
  bridge_transaction: {},
  loading_stripe: false,
  stripe_transaction: {},
  loading_plaid: false,
  plaid_transaction: null,
  plaid_failed: false,
  plaid_request_id: null,
  // initialize other state properties
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,

  reducers: {
    SET_TTRANSACTIONS: (state, action) => {
      state.transactions = action.payload;
    },
    SET_TTRANSACTIONS_DETAIL: (state, action) => {
      state.transactions_details = action.payload;
    },
    SET_TRANSACTION_COUNT: (state, action) => {
      state.transaction_count = action.payload;
    },
    SET_QUEUING_TRANSACTIONS: (state, action) => {
      state.queuing_transactions = action.payload;
    },
    SET_ZOJAPAY_TRANSACTIONS: (state, action) => {
      state.zojapy_transaction = action.payload;
    },
    SET_BRIDGE_TRANSACTIONS: (state, action) => {
      state.bridge_transaction = action.payload;
    },
    SET_STRIPE_TRANSACTIONS: (state, action) => {
      state.stripe_transaction = action.payload;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(getTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTransactions.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getTransactions.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(getTransactionCount.pending, (state) => {
      state.loading_count = true;
    });
    builder.addCase(getTransactionCount.fulfilled, (state) => {
      state.loading_count = false;
    });
    builder.addCase(getTransactionCount.rejected, (state) => {
      state.loading_count = false;
      return initialState;
    });
    builder.addCase(getTransactionDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTransactionDetails.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getTransactionDetails.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(approveTransactionPayout.pending, (state) => {
      state.loading_approval = true;
    });
    builder.addCase(approveTransactionPayout.fulfilled, (state) => {
      state.loading_approval = false;
    });
    builder.addCase(approveTransactionPayout.rejected, (state) => {
      state.loading_approval = false;
      return initialState;
    });
    builder.addCase(rejectTransactionPayout.pending, (state) => {
      state.loading_rejection = true;
    });
    builder.addCase(rejectTransactionPayout.fulfilled, (state) => {
      state.loading_rejection = false;
    });
    builder.addCase(rejectTransactionPayout.rejected, (state) => {
      state.loading_rejection = false;
      return initialState;
    });
    builder.addCase(retryTransactionPayout.pending, (state) => {
      state.loading_retry = true;
    });
    builder.addCase(retryTransactionPayout.fulfilled, (state) => {
      state.loading_retry = false;
    });
    builder.addCase(retryTransactionPayout.rejected, (state) => {
      state.loading_retry = false;
      return initialState;
    });
    builder.addCase(getQueuingTransaction.pending, (state) => {
      state.loading_queuing = true;
    });
    builder.addCase(getQueuingTransaction.fulfilled, (state) => {
      state.loading_queuing = false;
    });
    builder.addCase(getQueuingTransaction.rejected, (state) => {
      state.loading_queuing = false;
      return initialState;
    });
    builder.addCase(disburtAllQueuedTransactions.pending, (state) => {
      state.loading_disburse = true;
    });
    builder.addCase(disburtAllQueuedTransactions.fulfilled, (state) => {
      state.loading_disburse = false;
    });
    builder.addCase(disburtAllQueuedTransactions.rejected, (state) => {
      state.loading_disburse = false;
      return initialState;
    });
    builder.addCase(disburtSingleQueuedTransactions.pending, (state) => {
      state.loading_disburse = true;
    });
    builder.addCase(disburtSingleQueuedTransactions.fulfilled, (state) => {
      state.loading_disburse = false;
    });
    builder.addCase(disburtSingleQueuedTransactions.rejected, (state) => {
      state.loading_disburse = false;
      return initialState;
    });
    builder.addCase(getBridgeTransaction.pending, (state) => {
      state.loading_bridge = true;
    });
    builder.addCase(getBridgeTransaction.fulfilled, (state) => {
      state.loading_bridge = false;
    });
    builder.addCase(getBridgeTransaction.rejected, (state) => {
      state.loading_bridge = false;
      return initialState;
    });
    builder.addCase(getStripeTransaction.pending, (state) => {
      state.loading_stripe = true;
    });
    builder.addCase(getStripeTransaction.fulfilled, (state) => {
      state.loading_stripe = false;
    });
    builder.addCase(getStripeTransaction.rejected, (state) => {
      state.loading_stripe = false;
      return initialState;
    });
    // Only the latest request may update the list, so a slow response for an
    // old filter/page can't overwrite a newer one. A failure keeps the rows
    // already shown (no slice reset) and just stops the loading state.
    builder.addCase(getPlaidTransaction.pending, (state, action) => {
      state.loading_plaid = true;
      state.plaid_request_id = action.meta.requestId;
    });
    builder.addCase(getPlaidTransaction.fulfilled, (state, action) => {
      if (state.plaid_request_id !== action.meta.requestId) return;
      state.loading_plaid = false;
      state.plaid_failed = false;
      state.plaid_transaction = action.payload;
    });
    builder.addCase(getPlaidTransaction.rejected, (state, action) => {
      if (state.plaid_request_id !== action.meta.requestId) return;
      state.loading_plaid = false;
      state.plaid_failed = true;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_TTRANSACTIONS,
  SET_TRANSACTION_COUNT,
  SET_TTRANSACTIONS_DETAIL,
  SET_QUEUING_TRANSACTIONS,
  SET_ZOJAPAY_TRANSACTIONS,
  SET_BRIDGE_TRANSACTIONS,
  SET_STRIPE_TRANSACTIONS,
} = transactionSlice.actions;

export default transactionSlice.reducer;
